<form (ngSubmit)="onSubmit()" [formGroup]="formGroup" [id]="formId" class="relative">
  <div #scrollAnchor class="scroll-m-[calc(var(--app-toolbar-height)+2rem)]"></div>

  @if (errorFields.length > 0) {
    <parkour-error-summary [fields]="errorFields" class="container-1-col block my-4" />
  }

  <ng-content />
</form>
